import { SignInPage } from "Auth/Pages/SignInPage";
import { Error403Page } from "Infrastructure/Pages/Error403Page";
import { Error404Page } from "Infrastructure/Pages/Error404Page";
import { AccessRightCodes } from "Infrastructure/Models/AccessRightCodes";
import { AuthenticatedRoute } from "Infrastructure/Routing/AuthenticatedRoute";
import { UnauthenticatedRoute } from "Infrastructure/Routing/UnauthenticatedRoute";
import { AppRouting, getRoute } from "Infrastructure/Utils/UrlUtils";
import { createBrowserRouter } from "react-router-dom";
import { ClientDetailPage } from "Clients/Pages/UserDetailPage";
import { ClientsPage } from "Clients/Pages/UsersPage";
import { InstanceManagementPage } from "InstanceManagement/Pages/InstanceManagementPage";
import { ClientNewPage } from "Clients/Pages/UserNewPage";
import { CodelistManagementPage } from "CodelistManagement/Pages/CodelistManagementPage";
import { DashboardPage } from "Dashboard/Pages/DashboardPage";

const appRoutes = [
	{
		path: getRoute(AppRouting.SignIn),
		element: (
			<UnauthenticatedRoute>
				<SignInPage />
			</UnauthenticatedRoute>
		),
	},
	{
		path: getRoute(AppRouting.Dashboard),
		element: (
			<AuthenticatedRoute>
				<DashboardPage />
			</AuthenticatedRoute>
		),
	},
	{
		path: getRoute(AppRouting.InstanceManagement),
		element: (
			<AuthenticatedRoute requiredAccessRights={[AccessRightCodes.InstanceManagement]}>
				<InstanceManagementPage />
			</AuthenticatedRoute>
		),
	},
	{
		path: getRoute(AppRouting.CodelistManagement),
		element: (
			<AuthenticatedRoute requiredAccessRights={[AccessRightCodes.CodelistManagement]}>
				<CodelistManagementPage />
			</AuthenticatedRoute>
		),
	},
	{
		path: getRoute(AppRouting.Users),
		element: (
			<AuthenticatedRoute requiredAccessRights={[AccessRightCodes.UserManagement]}>
				<ClientsPage />
			</AuthenticatedRoute>
		),
	},
	{
		path: getRoute(AppRouting.UserDetail),
		element: (
			<AuthenticatedRoute requiredAccessRights={[AccessRightCodes.UserManagement]}>
				<ClientDetailPage />
			</AuthenticatedRoute>
		),
	},
	{
		path: getRoute(AppRouting.UserNew),
		element: (
			<AuthenticatedRoute requiredAccessRights={[AccessRightCodes.UserManagement]}>
				<ClientNewPage />
			</AuthenticatedRoute>
		),
	},
	{
		path: getRoute(AppRouting.Error403),
		element: <Error403Page />,
	},
	{
		path: "*",
		element: <Error404Page />,
	},
];

export const appRouter = createBrowserRouter(appRoutes, {
	basename: import.meta.env.VITE_BASE_URL,
});
